import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';

@Component({
  selector: 'app-social-landing-page',
  templateUrl: './social-landing-page.component.html',
  styleUrls: ['./social-landing-page.component.scss']
})
export class SocialLandingPageComponent implements OnInit {
  alert: Alert = null;
  isBrowser: boolean;

  constructor(
    public authManager: AuthManagerService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (authManager.isAuthenticated) {
      this.navigateToDashboard();
    }
    this.isBrowser = isPlatformBrowser(this.platformId);
   }

  private navigateToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  ngOnInit(): void {
  }

  closeAlert() {
    this.alert = null;
  }

  displayAlert(alertText: string) {
    this.alert = {
      type: 'danger',
      message: alertText
    };
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }
}
